<template>
    <div class="questionnaire">
        <div class="questionnaire-title-text">
            <div v-if="env === 'wxapp'" class="questionnaire-title-back" @click="goback">
                <img :src="backImg" alt="">
            </div>
            <div class="questionnaire-name">
                <span>{{questionnaireInfo.name}}</span>
                <div class="questionnaire-name-desc" @click="handleShowDesc">
                    <img :src="descImg" alt="" />
                </div>
            </div>
        </div>

        <div class="questionnaire-box">
            <div class="questionnaire-content" ref="questionnaire-content">
                <!-- 无跳题逻辑时 问卷一页展示 -->
                <div class="questionnaire-list" v-if="questionnaireInfo.is_jump_questionnaire == '0'">
                    <div :ref="`questionnaire-item-${questionKey}`" class="questionnaire-item" v-for="(questionItem, questionKey) in questionList" :key="questionKey">
                        <Radio v-model="questionData[questionKey]" :content="`${questionKey+1}、${questionItem.content}`" :options="questionItem.options" v-if="questionItem.type === questionTypeDict.radio"></Radio>

                        <Checkbox v-model="questionData[questionKey]" :content="`${questionKey+1}、${questionItem.content}`" :options="questionItem.options" v-if="questionItem.type === questionTypeDict.checkbox"></Checkbox>

                        <FillBlank v-model="questionData[questionKey]" :content="questionItem.content" v-if="questionItem.type === questionTypeDict.fillBlank" :questionnKey="questionKey+1"></FillBlank>

                        <BriefAnswer v-model="questionData[questionKey]" :content="`${questionKey+1}、${questionItem.content}`" v-if="questionItem.type === questionTypeDict.briefAnswer"></BriefAnswer>

                        <Scale v-model="questionData[questionKey]" :content="`${questionKey+1}、${questionItem.content}`" :options="questionItem.options" v-if="questionItem.type === questionTypeDict.scale"></Scale>

                        <Nationality v-model="questionData[questionKey]" :content="`${questionKey+1}、${questionItem.content}`" v-if="questionItem.type === questionTypeDict.nationality"></Nationality>

                        <District v-model="questionData[questionKey]" :content="`${questionKey+1}、${questionItem.content}`" v-if="questionItem.type === questionTypeDict.district"></District>

                        <Select v-model="questionData[questionKey]" :content="`${questionKey+1}、${questionItem.content}`" v-if="questionItem.type === questionTypeDict.select" :options="questionItem.options"></Select>

                        <IndividualFillBlank v-model="questionData[questionKey]" :content="`${questionKey+1}、${questionItem.content}`" v-if="questionItem.type === questionTypeDict.individualFillBlank"></IndividualFillBlank>

                        <MatrixFillBlank v-model="questionData[questionKey]" :content="`${questionKey+1}、${questionItem.content}`" v-if="questionItem.type === questionTypeDict.matrixFillBlank"></MatrixFillBlank>
                    </div>
                </div>

                <div class="questionnaire-list-bottom" v-if="questionnaireInfo.is_jump_questionnaire == '0'" @click="handleSubmit">提交</div>

                <!-- 有跳题逻辑时 问卷分页展示 -->
                <div class="questionnaire-list-jump">
                    <div class="questionnaire-item" :key="`questionnaire-item-${questionIndex}`" v-if="questionnaireInfo.is_jump_questionnaire == '1'">
                        <Radio v-model="questionData[questionIndex]" :content="`${jumpQuestionList.length}、${questionList[questionIndex].content}`" :options="questionList[questionIndex].options" v-if="questionList[questionIndex].type === questionTypeDict.radio"></Radio>

                        <Checkbox v-model="questionData[questionIndex]" :content="`${jumpQuestionList.length}、${questionList[questionIndex].content}`" :options="questionList[questionIndex].options" v-if="questionList[questionIndex].type === questionTypeDict.checkbox"></Checkbox>

                        <FillBlank v-model="questionData[questionIndex]" :content="questionList[questionIndex].content" v-if="questionList[questionIndex].type === questionTypeDict.fillBlank" :questionnKey="jumpQuestionList.length"></FillBlank>

                        <BriefAnswer v-model="questionData[questionIndex]" :content="`${jumpQuestionList.length}、${questionList[questionIndex].content}`" v-if="questionList[questionIndex].type === questionTypeDict.briefAnswer"></BriefAnswer>

                        <Scale v-model="questionData[questionIndex]" :content="`${jumpQuestionList.length}、${questionList[questionIndex].content}`" :options="questionList[questionIndex].options" v-if="questionList[questionIndex].type === questionTypeDict.scale"></Scale>

                        <Nationality v-model="questionData[questionIndex]" :content="`${jumpQuestionList.length}、${questionList[questionIndex].content}`" v-if="questionList[questionIndex].type === questionTypeDict.nationality"></Nationality>

                        <District v-model="questionData[questionIndex]" :content="`${jumpQuestionList.length}、${questionList[questionIndex].content}`" v-if="questionList[questionIndex].type === questionTypeDict.district"></District>

                        <Select v-model="questionData[questionIndex]" :content="`${jumpQuestionList.length}、${questionList[questionIndex].content}`" v-if="questionList[questionIndex].type === questionTypeDict.select" :options="questionList[questionIndex].options"></Select>

                        <IndividualFillBlank v-model="questionData[questionIndex]" :content="`${jumpQuestionList.length}、${questionList[questionIndex].content}`" v-if="questionList[questionIndex].type === questionTypeDict.individualFillBlank"></IndividualFillBlank>

                        <MatrixFillBlank v-model="questionData[questionIndex]" :content="`${jumpQuestionList.length}、${questionList[questionIndex].content}`" v-if="questionList[questionIndex].type === questionTypeDict.matrixFillBlank"></MatrixFillBlank>
                    </div>

                    <div class="questionnaire-list-jump-bottom" v-if="questionnaireInfo.is_jump_questionnaire == '1'">
                        <div v-if="questionIndex === 0" class="questionnaire-list-jump-bottom-first-next" @click="handleNext">下一题</div>

                        <div v-if="questionIndex > 0" class="questionnaire-list-jump-bottom-prev" @click="handlePrev">上一题</div>

                        <div v-if="questionIndex > 0" class="questionnaire-list-jump-bottom-next" @click="handleNext">{{questionIndex >= questionList.length - 1 ? '提交' : '下一题' }}</div>
                    </div>
                </div>
            </div>
        </div>

        <mlDialog v-model="showDesc" title="问卷说明" :content="questionnaireInfo.desc"></mlDialog>

        <sdDialog v-model="showSuccess" status="success" :content="submitQuestionnaireInfo.submit_questionnaire_desc" title="提交成功" cancelText="好的，我知道了" @cancel="handleExitCancel">
            <div>
                <div class="questionnaire-score" v-if="submitQuestionnaireInfo.is_show_score === '1'">
                    得分：<span>{{submitQuestionnaireInfo.score}}</span>分
                </div>
                <div class="questionnaire-qrcode" v-if="submitQuestionnaireInfo.is_show_qrcode === '1'">
                    <img :src="submitQuestionnaireInfo.qrcode_info" alt="" @click="showEnlarge">
                    <span>出示此二维码以扫描完成绑定</span>
                </div>
                <div class="desc">{{submitQuestionnaireInfo.desc}}</div>
                <div class="questionnaire-desc">{{submitQuestionnaireInfo.submit_questionnaire_desc}}</div>
            </div>
        </sdDialog>

        <div v-if="isEnlarged" class="enlarged-image-overlay" @click="hideEnlarge">
          <img class="enlarged-image" :src="submitQuestionnaireInfo.qrcode_info" alt="">
        </div>

        <sdDialog type="confirm" v-model="showExit" status="warning" content="当前正在答卷，确认退出嘛？" title="退出提示" cancelText="确认退出" confirmText="取消退出" @cancel="handleExitCancel">
        </sdDialog>

        <Loading v-model="showLoading" text="正在提交..."></Loading>
    </div>
</template>

<script>
import { Toast, Dialog } from 'vant';
import { filterFillBlankText } from "@/utils/common"
import { getENV, isEmpty, getRequestClient } from '../../../utils/common'
import backImg from '@/assets/reserve/questionnaire/back.png'
import descImg from '@/assets/reserve/questionnaire/desc.png'
import { questionTypeDict } from '@/utils/dict.js'
import Radio from './components/radio.vue'
import Checkbox from './components/checkbox.vue'
import FillBlank from './components/fillBlank.vue'
import BriefAnswer from './components/briefAnswer.vue'
import Scale from './components/scale.vue'
import Nationality from './components/nationality.vue'
import District from './components/district.vue'
import Select from './components/select.vue'
import IndividualFillBlank from './components/individualFillBlank.vue'
import MatrixFillBlank from './components/matrixFillBlank.vue'
import mlDialog from '@/components/dialog/dialog.vue'
import sdDialog from '@/components/dialog/$dialog'
import Loading from '@/components/loading/loading'
export default {
    components: {
        Radio,
        Checkbox,
        FillBlank,
        BriefAnswer,
        Scale,
        mlDialog,
        Nationality,
        District,
        Select,
        IndividualFillBlank,
        MatrixFillBlank,
        sdDialog,
        Loading
    },
    data() {
        return {
            backImg: backImg,
            descImg: descImg,
            questionTypeDict: questionTypeDict,
            questionnaireInfo: {},
            questionList: [],
            questionData: [],
            env: "",//getENV(),
            showDesc: false,
            showSuccess: false,
            showExit: false,
            showLoading: false,
            questionIndex: 0,
            jumpQuestionList: [0],
            startDate: new Date().getTime(),
            token: "",
            naire_code: "",
            qrcode: "",
            submitQuestionnaireInfo: {},
            isSubmit: false,
            isEnlarged: false
        }
    },
    mounted() {
        const query = this.$route.query
        if (query && query.qrcode) {
            this.qrcode = query.qrcode
            this.$axios({
                url: '/mldyue/common/qrcode-get-questionnaire-question',
                data: {
                    qrcode_content: query.qrcode
                },
                headers: {
                    requestClient: getRequestClient()
                }
            }).then((res) => {
                const questionList = res.data.questions
                delete res.data.questions
                if (!res.data.submit_questionnaire_desc) {
                    res.data.submit_questionnaire_desc = '您的答卷已经提交，感谢您的参与！'
                }
                this.questionnaireInfo = res.data
                this.questionList = questionList
            })
            return
        }
        if (query && query.naire_code) {
            this.token = query.token
            this.naire_code = query.naire_code
            this.$axios({
                url: '/mldyue/user/get-questionnaire-question',
                data: {
                    token: query.token,
                    naire_code: query.naire_code
                },
                headers: {
                    requestClient: getRequestClient()
                }
            }).then((res) => {
                const questionList = res.data.questions
                delete res.data.questions
                if (!res.data.submit_questionnaire_desc) {
                    res.data.submit_questionnaire_desc = '您的答卷已经提交，感谢您的参与！'
                }
                this.questionnaireInfo = res.data
                this.questionList = questionList
            })
        } else {
            Dialog.alert({
                message: '无问卷code',
            })
        }
    },
    computed: {
        realQuestionData() {
            let num = 0
            for (let i = 0; i < this.questionData.length; i++) {
                if (!isEmpty(this.questionData[i])) {
                    num++
                }
            }
            return num
        }
    },
    methods: {
        /**
            点击返回按钮的回调事件
            @param
            @return
        */
        goback() {
            if (getENV() === 'wxapp') {
                wx.miniProgram.navigateBack({
                    delta: 1
                })
                wx.miniProgram.postMessage({
                    data: {
                        type: 'success'
                    }
                })
            }
        },



        /**
            处理点击确认退出事件
            @param
            @return
        */
        handleExitCancel() {
            this.goback()
        },

        /**
            处理下一题事件
            @param
            @return
        */
        handleNext() {
            const { questionData, questionIndex, questionList } = this, result = questionData[questionIndex], questionItem = questionList[questionIndex]
            if (isEmpty(result)) {
                Toast('该题暂未作答，请作答')
                return
            }
            if (questionItem.type === questionTypeDict.matrixFillBlank && Array.isArray(result)) {
                let resultLen = 0
                for (let i = 0; i < result.length; i++) {
                    if (!isEmpty(result[i])) {
                        resultLen++
                    }
                }
                const spaceList = questionItem.content.match(/###/g)
                const spaceNum = Array.isArray(spaceList) ? spaceList.length + 1 : 1
                if (spaceNum > resultLen) {
                    Toast('有问题未作答，请作答')
                    return
                }

            }

            if (questionItem.type === questionTypeDict.fillBlank && Array.isArray(result)) {
                const content = filterFillBlankText(questionItem.content)
                let resultLen = 0
                for (let i = 0; i < result.length; i++) {
                    if (!isEmpty(result[i])) {
                        resultLen++
                    }
                }
                const space = content.match(/###/g).length
                if (space > resultLen) {
                    Toast('有问题未作答，请作答')
                    return
                }
            }

            // 是否到题目末尾
            if (questionIndex >= questionList.length - 1) {
                this.handleQuestionEnd()
            } else {
                // 无条件跳题
                if (questionItem.jump_type === '2') {
                    if (questionItem.jump_mode === '3') {
                        this.handleJumpMode3(questionItem.jump_question_code)
                    } else if (questionItem.jump_mode === '2') {
                        this.handleQuestionEnd()
                    } else {
                        this.handleJumpModeDefault()
                    }
                } else if (questionItem.jump_type === '1') {
                    for (let i = 0; i < questionItem.options.length; i++) {
                        const option = questionItem.options[i]
                        if (option.code === result[0]) {
                            if (option.jump_mode === '3') {
                                this.handleJumpMode3(option.jump_question_code)
                            } else if (option.jump_mode === '2') {
                                this.handleQuestionEnd()
                            } else {
                                this.handleJumpModeDefault()
                            }
                            break
                        }

                    }
                } else {
                    this.handleJumpModeDefault()
                }
            }
        },

        /**
            处理点击提交事件
            @param
            @return
        */
        handleSubmit() {
            if (this.isSubmit) {
                return
            }
            this.isSubmit = true
            const { questionList, questionData } = this
            for (let i = 0; i < questionList.length; i++) {
                const questionItem = questionList[i], data = questionData[i]
                if (isEmpty(data)) {
                    Toast('有问题未作答，请作答')
                    this.isSubmit = false
                    this.handleJumpError(i)
                    return
                }
                if (questionItem.type === questionTypeDict.matrixFillBlank) {
                    let resultLen = 0
                    for (let i = 0; i < data.length; i++) {
                        if (!isEmpty(data[i])) {
                            resultLen++
                        }
                    }
                    const spaceList = questionItem.content.match(/###/g)
                    const spaceNum = Array.isArray(spaceList) ? spaceList.length + 1 : 1
                    if (spaceNum > resultLen) {
                        Toast('有问题未作答，请作答')
                        this.isSubmit = false
                        this.handleJumpError(i)
                        return
                    }
                }

                if (questionItem.type === questionTypeDict.fillBlank) {
                    const content = filterFillBlankText(questionItem.content)
                    let resultLen = 0
                    for (let i = 0; i < data.length; i++) {
                        if (!isEmpty(data[i])) {
                            resultLen++
                        }
                    }
                    const space = content.match(/###/g).length
                    if (space > resultLen) {
                        this.isSubmit = false
                        this.handleJumpError(i)
                        Toast('有问题未作答，请作答')
                        return
                    }
                }
            }
            this.handleQuestionEnd()
        },

        /**
            处理跳转错误的题目
            @param { number } index 问题下标
            @return
        */
        handleJumpError(index) {
            const content = this.$refs[`questionnaire-content`], item = this.$refs[`questionnaire-item-${index}`]
            if (Array.isArray(item) && item.length) {
                content.scrollTo({
                    top: item[0].offsetTop
                })
            }
        },

        /**
            处理跳题方式为跳转指定问题
            @param { String } code 问题code
            @return
        */
        handleJumpMode3(code) {
            const questionIndex = this.getQuestionIndex(code)
            this.questionIndex = questionIndex
            this.jumpQuestionList.push(questionIndex)
        },

        /**
            处理默认跳题/跳转下一题
            @param
            @return
        */
        handleJumpModeDefault() {
            this.questionIndex++
            this.jumpQuestionList.push(this.questionIndex)
        },

        /**
            处理题目事件
            @param
            @return
        */
        handleQuestionEnd() {
            const currDate = new Date().getTime()
            const { questionList, questionData, questionnaireInfo } = this
            let answers = []
            for (let i = 0; i < questionList.length; i++) {
                if (Array.isArray(questionData[i]) && questionData[i].length) {
                    let questionItem = questionList[i], answerData = questionData[i]
                    if (questionItem.type === questionTypeDict.district) {
                        answerData = questionData[i].map((item) => {
                            return item.text
                        })
                    }
                    answers.push({
                        question_code: questionList[i].code,
                        answer: answerData
                    })
                }
            }
            this.showLoading = true
            const params = {
                time: Math.round((currDate - this.startDate) / 1000),
                answers: answers
            }
            if (this.qrcode) {
                params.pi_uid = questionnaireInfo.pi_uid
                params.phone = questionnaireInfo.phone
                params.name = questionnaireInfo.name
                params.naire_code = questionnaireInfo.code
            } else {
                params.naire_code = this.naire_code,
                params.token = this.token
            }
            this.handleSubmitQuestion(params).then((res) => {
                this.submitQuestionnaireInfo = res.data
                this.showSuccess = true
                this.isSubmit = false
                this.showLoading = false
            }).catch(() => {
                this.isSubmit = false
                this.showLoading = false
            })
        },

        /**
            处理提交问卷事件
            @param { Object } params 问卷数据
            @return
        */
        handleSubmitQuestion(params) {
            return new Promise((resolve, reject) => {
                if (this.qrcode) {
                    this.$axios({
                        url: '/mldyue/common/submit-questionnaire',
                        data: { ...params },
                        headers: {
                            requestClient: getRequestClient()
                        }
                    }).then((res) => {
                        resolve(res)
                    }).catch(() => {
                        reject()
                    })
                } else {
                    this.$axios({
                        url: '/mldyue/user/submit-questionnaire',
                        data: { ...params },
                        headers: {
                            requestClient: getRequestClient()
                        }
                    }).then((res) => {
                        resolve(res)
                    }).catch(() => {
                        reject()
                    })
                }
            })
        },
        /**
            处理上一题事件
            @param
            @return
        */
        handlePrev() {
            const { jumpQuestionList } = this, jumpQuestionLen = jumpQuestionList.length
            this.questionIndex = jumpQuestionList[jumpQuestionLen - 2]
            this.jumpQuestionList.pop()
        },

        /**
            根据题目code获取题目下标
            @param
            @return
        */
        getQuestionIndex(code) {
            for (let i = 0; i < this.questionList.length; i++) {
                const questionItem = this.questionList[i]
                if (questionItem.code === code) {
                    return i
                }
            }
            return 0
        },

        /**
            处理显示问卷说明
            @param
            @return
        */
        handleShowDesc() {
            this.showDesc = true
        },
        showEnlarge() {
          this.isEnlarged = true;
        },
        hideEnlarge() {
          this.isEnlarged = false;
        }
    }
}
</script>

<style lang="scss" scoped>
.questionnaire {
    display: flex;
    flex-direction: column;
    height: 100%;
}
.questionnaire-title-text {
    padding: 0 0.32rem 0.32rem;
    background: linear-gradient(90deg, #febaba 0%, #f86190 100%);
    .questionnaire-title-back {
        display: inline-block;
        padding: 0.16rem 0.16rem 0 0;
        img {
            display: block;
            width: 0.4rem;
            height: 0.4rem;
        }
    }
    .questionnaire-name {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-top: 0.4rem;
        padding-bottom: 0.42rem;
        min-height: 1.06rem;
        > span {
            font-size: 0.4rem;
            line-height: 0.56rem;
            font-weight: bold;
            color: #fff;
        }
        .questionnaire-name-desc {
            padding: 0.08rem 0.16rem;
        }
        img {
            display: block;
            width: 0.32rem;
            height: 0.32rem;
        }
    }
}

.questionnaire-box {
    position: relative;
    flex: 1;
}

.desc {
  text-align: left;
  font-size: 0.24rem;
  color: #f86190;
}

.questionnaire-desc {
    text-align: left;
    font-size: 0.24rem;
}

.questionnaire-score {
    margin-bottom: 0.32rem;
    text-align: center;
    font-size: 0.24rem;
    > span {
        font-size: 0.64rem;
        line-height: 0.9rem;
        color: #f86190;
    }
}

.questionnaire-qrcode {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0.32rem;
    > img {
        width: 1.92rem;
        height: 1.92rem;
    }
    > span {
        margin-top: 0.16rem;
        font-size: 0.24rem;
        line-height: 0.34rem;
        color: #c3c3c3;
    }
}

.questionnaire-content {
    overflow-y: auto;
    position: absolute;
    top: -0.32rem;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.64rem 0.64rem 0.72rem;
    border-radius: 0.32rem 0.32rem 0px 0px;
    background-color: #fff;
    .questionnaire-item {
        margin-bottom: 0.48rem;
    }

    .questionnaire-list-bottom {
        width: 3.6rem;
        height: 0.88rem;
        margin: 1.12rem auto 0;
        border-radius: 0.48rem;
        text-align: center;
        line-height: 0.88rem;
        color: #fff;
        background: linear-gradient(90deg, #febaba 0%, #f86190 100%);
    }

    .questionnaire-list-jump {
        /deep/ .questionnaire-title {
            margin-bottom: 0.48rem;
        }
        /deep/
            .questionnaire-matrixFillBlank-list
            .questionnaire-matrixFillBlank-input
            > div {
            margin-bottom: 0.24rem;
        }
        .questionnaire-list-jump-bottom {
            display: flex;
            flex-direction: row;
            justify-content: center;
            position: absolute;
            bottom: 1.12rem;
            left: 0;
            right: 0;
            height: 0.88rem;
            .questionnaire-list-jump-bottom-first-next {
                width: 3.6rem;
                height: 100%;
                border-radius: 0.48rem;
                text-align: center;
                line-height: 0.88rem;
                color: #fff;
                background: linear-gradient(90deg, #febaba 0%, #f86190 100%);
            }

            .questionnaire-list-jump-bottom-prev {
                width: 3.04rem;
                height: 100%;
                margin-right: 0.16rem;
                border-radius: 0.48rem;
                text-align: center;
                line-height: 0.88rem;
                color: #f86190;
                background-color: #ffdede;
            }

            .questionnaire-list-jump-bottom-next {
                width: 3.04rem;
                height: 100%;
                border-radius: 0.48rem;
                text-align: center;
                line-height: 0.88rem;
                color: #fff;
                background: linear-gradient(90deg, #febaba 0%, #f86190 100%);
            }
        }
    }
}

.enlarged-image-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.enlarged-image {
  max-width: 90%;
  max-height: 90%;
}
</style>



// WEBPACK FOOTER //
// src/pages/reserve/questionnaire/index.vue